import React from "react";
import { theme } from "../theme/theme";
import styled from "styled-components";

export const SocialMedia = ({ data }) => {
  return (
    <Div className="SocialMedia">
      {data.map((item, i) => {
        switch (item.socialMedia) {
          case "LinkedIn":
            return (
              <a
                key={i}
                className="socialLink"
                rel="noreferrer"
                target="_blank"
                href={item.url}
                aria-label="Linkedin"
              >
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.3383 0.252806C19.6988 0.252806 20.0593 0.433049 20.3297 0.703413C20.6 0.973777 20.7803 1.33426 20.7803 1.69475V18.998C20.7803 19.4036 20.6 19.7641 20.3297 20.0344C20.0593 20.3048 19.6988 20.44 19.3383 20.44H2.03502C1.62947 20.44 1.26899 20.3048 0.998622 20.0344C0.728258 19.7641 0.593076 19.4036 0.593076 18.998V1.69475C0.593076 1.33426 0.728258 0.973777 0.998622 0.703413C1.26899 0.433049 1.62947 0.252806 2.03502 0.252806H19.3383ZM6.67627 17.5561H6.72133V7.91312H3.70226V17.5561H6.67627ZM5.18926 6.60636C5.63987 6.60636 6.04542 6.47118 6.4059 6.11069C6.76639 5.75021 6.94663 5.34466 6.94663 4.89406C6.94663 4.44345 6.76639 4.0379 6.4059 3.67742C6.04542 3.31693 5.63987 3.13669 5.18926 3.13669C4.6936 3.13669 4.28805 3.31693 3.97263 3.67742C3.61214 4.0379 3.47696 4.44345 3.47696 4.89406C3.47696 5.34466 3.61214 5.75021 3.97263 6.11069C4.28805 6.47118 4.6936 6.60636 5.18926 6.60636ZM17.8964 17.5561V12.284C17.8964 10.797 17.6711 9.71555 17.2655 8.99458C16.6797 8.13842 15.6884 7.68782 14.3366 7.68782C13.6156 7.68782 13.0298 7.86806 12.4891 8.18348C12.0385 8.45385 11.678 8.81433 11.4978 9.21988H11.4527V7.91312H8.56882V17.5561H11.5428V12.7797C11.5428 12.0587 11.6329 11.4729 11.8582 11.0674C12.1286 10.5717 12.6243 10.3013 13.3452 10.3013C14.0212 10.3013 14.4718 10.6168 14.6971 11.1575C14.8322 11.518 14.9224 12.1038 14.9224 12.8698V17.5561H17.8964Z"
                    fill="white"
                  />
                </svg>
              </a>
            );
            break;
          case "Facebook":
            return (
              <a
                target="_blank"
                rel="noreferrer"
                className="socialLink"
                href={item.url}
                aria-label="Facebook"
              >
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.9212 1.37932C20.9212 1.0639 20.786 0.793534 20.5607 0.568231C20.3354 0.387988 20.065 0.252806 19.7946 0.252806H1.8605C1.50002 0.252806 1.22965 0.387988 1.04941 0.568231C0.824105 0.793534 0.733984 1.0639 0.733984 1.37932V19.3135C0.733984 19.6289 0.824105 19.8993 1.04941 20.1246C1.22965 20.3499 1.50002 20.44 1.8605 20.44H11.5035V12.5994H8.88997V9.58037H11.5035V7.32733C11.5035 6.06563 11.864 5.0743 12.5849 4.35333C13.3059 3.67742 14.2522 3.31693 15.4238 3.31693C16.325 3.31693 17.1361 3.36199 17.7669 3.40705V6.15575H16.1447C15.5589 6.15575 15.1534 6.29094 14.9281 6.5613C14.7479 6.7866 14.6577 7.14709 14.6577 7.64276V9.58037H17.6768L17.2713 12.5994H14.6577V20.44H19.7946C20.1101 20.44 20.3804 20.3499 20.6057 20.1246C20.786 19.8993 20.9212 19.6289 20.9212 19.3135V1.37932Z"
                    fill="white"
                  />
                </svg>
              </a>
            );
            break;
          case "Twitter":
            return (
              <a
                key={i}
                target="_blank"
                rel="noreferrer"
                className="socialLink"
                href={item.url}
                aria-label="Twitter"
              >
                <svg
                  width="24"
                  height="20"
                  viewBox="0 0 1200 1227"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z"
                    fill="white"
                  />
                </svg>
              </a>
            );
            break;
          case "Vimeo":
            return (
              <a
                key={i}
                target="_blank"
                rel="noreferrer"
                className="socialLink"
                href={item.url}
                aria-label="Vimeo"
              >
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.8541 0.252806C19.3948 0.252806 19.8905 0.478109 20.296 0.838595C20.6565 1.24414 20.8818 1.73981 20.8818 2.28054V18.4123C20.8818 18.998 20.6565 19.4937 20.296 19.8542C19.8905 20.2597 19.3948 20.44 18.8541 20.44H2.72237C2.13658 20.44 1.64091 20.2597 1.28043 19.8542C0.874881 19.4937 0.694638 18.998 0.694638 18.4123V2.28054C0.694638 1.73981 0.874881 1.24414 1.28043 0.838595C1.64091 0.478109 2.13658 0.252806 2.72237 0.252806H18.8541ZM17.6825 6.96685C17.7726 5.0743 17.0517 4.08296 15.5647 4.0379C13.5369 3.99284 12.1851 5.11936 11.4641 7.46251C12.0049 7.23721 12.4555 7.19215 12.861 7.28227C13.3567 7.41745 13.582 7.823 13.5369 8.49891C13.4468 8.99458 13.1314 9.71555 12.5456 10.6618C11.9147 11.6081 11.4641 12.1038 11.1487 12.1488C10.8333 12.1939 10.5629 11.7433 10.2926 10.8421C10.0673 10.1211 9.79689 8.67915 9.48147 6.5613C9.21111 4.89406 8.49014 4.12802 7.40868 4.21815C7.00313 4.26321 6.50747 4.53357 5.92168 4.98418C5.51613 5.2996 4.88528 5.84033 4.02913 6.60636L3.08285 7.41745L3.80382 8.31867C4.43467 7.86806 4.79516 7.64276 4.93034 7.64276C5.29083 7.64276 5.60625 8.09336 5.96674 8.90446C6.14698 9.49024 6.50747 10.7069 7.04819 12.5544L7.4988 14.3117C8.08459 15.8889 8.80556 16.6549 9.66171 16.6549C11.0135 16.6549 12.7258 15.3932 14.7085 12.7797C16.6011 10.3464 17.5924 8.40879 17.6825 6.96685Z"
                    fill="white"
                  />
                </svg>
              </a>
            );
            break;
          case "YouTube":
            return (
              <a
                key={i}
                target="_blank"
                rel="noreferrer"
                className="socialLink"
                href={item.url}
                aria-label="YouTube"
              >
                <svg
                  width="26"
                  height="18"
                  viewBox="0 0 26 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24.735 3.39839C24.9152 4.20948 25.0955 5.47118 25.1856 7.09336L25.2306 9.3464L25.1856 11.5994C25.0955 13.3117 24.9152 14.5284 24.735 15.3395C24.5547 15.8802 24.2844 16.3308 23.9239 16.6913C23.5183 17.0968 23.0677 17.3672 22.527 17.5024C21.7159 17.7277 19.9135 17.8629 17.0296 17.953L12.9291 17.998L8.82855 17.953C5.94467 17.8629 4.09718 17.7277 3.33115 17.5024C2.79042 17.3672 2.29475 17.0968 1.93427 16.6913C1.52872 16.3308 1.25836 15.8802 1.12318 15.3395C0.897872 14.5284 0.76269 13.3117 0.672569 11.5994L0.627508 9.3464C0.627508 8.71555 0.627508 7.94952 0.672569 7.09336C0.76269 5.47118 0.897872 4.20948 1.12318 3.39839C1.25836 2.85766 1.52872 2.40705 1.93427 2.00151C2.29475 1.64102 2.79042 1.37066 3.33115 1.19041C4.09718 1.01017 5.94467 0.829929 8.82855 0.739808L12.9291 0.694747L17.0296 0.739808C19.9135 0.829929 21.7159 1.01017 22.527 1.19041C23.0677 1.37066 23.5183 1.64102 23.9239 2.00151C24.2844 2.40705 24.5547 2.85766 24.735 3.39839ZM10.4057 13.0414L16.8494 9.3464L10.4057 5.69648V13.0414Z"
                    fill="white"
                  />
                </svg>
              </a>
            );
            break;
          case "Instagram":
            return (
              <a
                key={i}
                target="_blank"
                rel="noreferrer"
                className="socialLink"
                href={item.url}
                aria-label="Instagram"
              >
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.2628 5.16442C11.1641 5.16442 12.0202 5.43478 12.8313 5.88539C13.6424 6.336 14.2732 6.96685 14.7238 7.77794C15.1745 8.58903 15.4448 9.44518 15.4448 10.3464C15.4448 11.2927 15.1745 12.1488 14.7238 12.9599C14.2732 13.771 13.6424 14.4019 12.8313 14.8525C12.0202 15.3031 11.1641 15.5284 10.2628 15.5284C9.31656 15.5284 8.46041 15.3031 7.64932 14.8525C6.83823 14.4019 6.20738 13.771 5.75677 12.9599C5.30616 12.1488 5.08086 11.2927 5.08086 10.3464C5.08086 9.44518 5.30616 8.58903 5.75677 7.77794C6.20738 6.96685 6.83823 6.336 7.64932 5.88539C8.46041 5.43478 9.31656 5.16442 10.2628 5.16442ZM10.2628 13.7259C11.1641 13.7259 11.9751 13.4105 12.6511 12.7346C13.2819 12.1038 13.6424 11.2927 13.6424 10.3464C13.6424 9.44518 13.2819 8.63409 12.6511 7.95818C11.9751 7.32733 11.1641 6.96685 10.2628 6.96685C9.31656 6.96685 8.50547 7.32733 7.87462 7.95818C7.19871 8.63409 6.88329 9.44518 6.88329 10.3464C6.88329 11.2927 7.19871 12.1038 7.87462 12.7346C8.50547 13.4105 9.31656 13.7259 10.2628 13.7259ZM16.8868 4.93912C16.8868 4.62369 16.7516 4.35333 16.5263 4.08296C16.2559 3.85766 15.9855 3.72248 15.6701 3.72248C15.3096 3.72248 15.0393 3.85766 14.814 4.08296C14.5436 4.35333 14.4535 4.62369 14.4535 4.93912C14.4535 5.2996 14.5436 5.56997 14.814 5.79527C15.0393 6.06563 15.3096 6.15575 15.6701 6.15575C15.9855 6.15575 16.2559 6.06563 16.4812 5.79527C16.7065 5.56997 16.8417 5.2996 16.8868 4.93912ZM20.3114 6.15575C20.3114 7.01191 20.3564 8.40879 20.3564 10.3464C20.3564 12.3291 20.3114 13.7259 20.2663 14.5821C20.2212 15.4383 20.0861 16.1592 19.9058 16.7901C19.6355 17.5561 19.1849 18.232 18.6441 18.7727C18.1034 19.3135 17.4275 19.719 16.7065 19.9894C16.0757 20.2147 15.3096 20.3499 14.4535 20.3949C13.5973 20.44 12.2004 20.44 10.2628 20.44C8.28017 20.44 6.88329 20.44 6.02714 20.3949C5.17098 20.3499 4.45001 20.2147 3.81916 19.9443C3.05313 19.719 2.37722 19.3135 1.83649 18.7727C1.29576 18.232 0.890218 17.5561 0.619854 16.7901C0.394551 16.1592 0.259369 15.4383 0.214308 14.5821C0.169248 13.7259 0.169248 12.3291 0.169248 10.3464C0.169248 8.40879 0.169248 7.01191 0.214308 6.15575C0.259369 5.2996 0.394551 4.53357 0.619854 3.90272C0.890218 3.18175 1.29576 2.50584 1.83649 1.96511C2.37722 1.42438 3.05313 0.973777 3.81916 0.703413C4.45001 0.52317 5.17098 0.387988 6.02714 0.342927C6.88329 0.297867 8.28017 0.252806 10.2628 0.252806C12.2004 0.252806 13.5973 0.297867 14.4535 0.342927C15.3096 0.387988 16.0757 0.52317 16.7065 0.703413C17.4275 0.973777 18.1034 1.42438 18.6441 1.96511C19.1849 2.50584 19.6355 3.18175 19.9058 3.90272C20.0861 4.53357 20.2212 5.2996 20.3114 6.15575ZM18.1485 16.2944C18.3287 15.7987 18.4188 14.9876 18.5089 13.8611C18.5089 13.2303 18.554 12.284 18.554 11.0674V9.62543C18.554 8.40879 18.5089 7.46251 18.5089 6.83166C18.4188 5.70515 18.3287 4.89406 18.1485 4.39839C17.788 3.49717 17.1121 2.82126 16.2108 2.46078C15.7152 2.28054 14.9041 2.19041 13.7776 2.10029C13.1017 2.10029 12.1554 2.05523 10.9838 2.05523H9.54187C8.32523 2.05523 7.37896 2.10029 6.74811 2.10029C5.62159 2.19041 4.8105 2.28054 4.31483 2.46078C3.36856 2.82126 2.73771 3.49717 2.37722 4.39839C2.19698 4.89406 2.0618 5.70515 2.01674 6.83166C1.97167 7.50757 1.97167 8.45385 1.97167 9.62543V11.0674C1.97167 12.284 1.97167 13.2303 2.01674 13.8611C2.0618 14.9876 2.19698 15.7987 2.37722 16.2944C2.73771 17.2407 3.41362 17.8715 4.31483 18.232C4.8105 18.4123 5.62159 18.5474 6.74811 18.5925C7.37896 18.6376 8.32523 18.6376 9.54187 18.6376H10.9838C12.2004 18.6376 13.1467 18.6376 13.7776 18.5925C14.9041 18.5474 15.7152 18.4123 16.2108 18.232C17.1121 17.8715 17.788 17.1956 18.1485 16.2944Z"
                    fill="white"
                  />
                </svg>
              </a>
            );
            break;
          default:
            return null;
        }
      })}
    </Div>
  );
};

const Div = styled.div`
  display: flex;
  a {
    padding: 4px;

    svg {
      width: 30px;
      height: 30px;
      path {
        fill: ${theme.primary};
      }
    }
    &:hover {
      opacity: 0.8;
    }
  }
  a:not(:last-child) {
    margin-right: 10px;
  }
`;
